import { styled } from '@mui/material/styles';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import TextInput from '../../forms/TextInput';
import Checkbox from '../../forms/Checkbox';
import SelectMenu from '../../forms/SelectMenu';
import { TripLegOverrideReason } from '../../../data/models/trip-leg-override-reason.model';
import { ServicePlan } from '../../../data/models/service-plan.model';

const PREFIX = 'OverrideForm';

const classes = {
  container: `${PREFIX}-container`,
  previous: `${PREFIX}-previous`,
  title: `${PREFIX}-title`,
  form: `${PREFIX}-form`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'space-around',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
  },

  [`& .${classes.previous}`]: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    marginLeft: theme.spacing(-2),
  },

  [`& .${classes.title}`]: {
    marginLeft: theme.spacing(-2),
  },

  [`& .${classes.form}`]: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: 500,
    marginLeft: theme.spacing(2),
  },
}));

interface OverrideFormProps {
  overrideReasons: TripLegOverrideReason[];
  servicePlans: ServicePlan[];
  formHook: UseFormReturn<any, any>;
}

export default function OverrideForm({
  formHook,
  overrideReasons,
  servicePlans,
}: OverrideFormProps) {
  const { t } = useTranslation('common');
  const requiredFieldMessage = t('common.requiredField');

  return (
    <StyledBox className={classes.container}>
      <Box className={classes.form}>
        <TextInput
          name="OverrideFirstName"
          label={t('reservation.overrideFirstName')}
          control={formHook.control}
          required={true}
          rules={{ required: requiredFieldMessage }}
        />
        <TextInput
          name="OverrideLastName"
          label={t('reservation.overrideLastName')}
          control={formHook.control}
          required={true}
          rules={{ required: requiredFieldMessage }}
        />
        <SelectMenu
          label={t('reservation.overrideReason')}
          name={`OverrideReason`}
          values={overrideReasons}
          valueAttr="tripLegOverrideReasonBC"
          labelAttr="tripLegOverrideReasonName"
          control={formHook.control}
          required={true}
          rules={{ required: requiredFieldMessage }}
        />

        {servicePlans && (
          <SelectMenu
            label={t('passenger.servicePlan')}
            name="ServicePlan"
            values={servicePlans}
            valueAttr="servicePlanUUID"
            labelAttr="clientServicePlanName"
            required={true}
            control={formHook.control}
            rules={{ required: requiredFieldMessage }}
          />
        )}
        <Checkbox
          name="AllowOverride"
          label={t('reservation.requestOverride')}
          control={formHook.control}
          disabled={false}
        />
      </Box>
    </StyledBox>
  );
}
